import axios from 'axios';
import DataSvc from './data';

class Session {
  static resume() {
    const user = this.getUser();
    let promise;

    if (user) {
      axios.defaults.headers.common.Authorization = `Bearer ${user.auth_token}`;
      promise = DataSvc.tokenAuth().then(() => this.begin(user));
    } else {
      promise = Promise.reject(new Error('Invalid session. Please sign in again.'));
    }

    promise.catch(Session.end);

    return promise;
  }

  static begin(user) {
    const orgPromise = user.permissions.includes('superadmin')
      ? DataSvc.getOrganizations()
      : DataSvc.getOrganization(user.admin_organization_id)
        .then(organization => [organization]);

    return orgPromise.then(organizations => [user, organizations]);
  }

  static update(user) {
    const u = JSON.stringify(user);
    localStorage.setItem('user', u);
  }

  static end() {
    delete axios.defaults.headers.common.Authorization;
    localStorage.removeItem('user');
  }

  static getUser() {
    const user = localStorage.getItem('user');
    return JSON.parse(user);
  }
}

export default Session;
